/* global angular */

var ngModule = angular.module('trends');

ngModule.config(['RestangularProvider', function (RestangularProvider) {
    RestangularProvider.setBaseUrl('/trends/api/v1');
    RestangularProvider.setRequestSuffix('/?'); // IE fix

    // Intercept Tastypie output and turn it into a list
    RestangularProvider.addResponseInterceptor(function (raw, op) {
        var data;

        if (op === 'getList') {
            data = raw.objects;
            data.meta = raw.meta; // Set meta as a property on the list
        } else {
            data = raw;
        }

        return data;
    });
}]);

ngModule.service('Api', ['Restangular', function (Restangular) {
    // TODO Use camelCase
    this.filters = {
        demographic: Restangular.all('demographic'),
        driver: Restangular.all('driver'),
        region: Restangular.all('region'),
        sector: Restangular.all('sector'),
        theme: Restangular.all('theme')
    };
    this.content = {
        trend: Restangular.all('trend'),
        trendpdf: Restangular.all('trendpdf'),
        observation: Restangular.all('observation'),
        specific: Restangular.all('specific'),
        news_keystat: Restangular.all('newskeystat'),
        webinar: Restangular.all('webinar'),
        ppt_slideshow: Restangular.all('trendppt'),
        ppt_preview: Restangular.all('trendpptimages'),
        history: Restangular.all('trendhistory'),
        feedblog: Restangular.all('feedblog')
    };
    this.alerts = {
        hvt: Restangular.all('hvtalert'),
        item: Restangular.all('itemalert'),
        newsletter: Restangular.all('newsletteralert'),
        savedsearch: Restangular.all('searchalert')
    };
    this.labels = {
        label: Restangular.all('pillar'),
        label_group: Restangular.all('trendlabelgroup')
    };
    this.search = {
        trend: Restangular.all('search/trend'),
        observation: Restangular.all('search/observation'),
        mapp: Restangular.all('search/ma'),
        webinar: Restangular.all('search/webinar')
    };
    this.search_filters = Restangular.one('search/filters');
    this.hvt_type = Restangular.all('hvt_type');
    this.wiif = Restangular.all('wiif');
    this.market_application = Restangular.all('mapp');
    this.trend_meta = Restangular.all('trendmeta');

    this.feedback = Restangular.all('feedback');

    this.alert_frequency = Restangular.all('alertfrequency');
    this.export_basket = Restangular.allUrl('export_basket', '/sinatra/oxygen/export/json');
    this.pdf_download = {
        trend: Restangular.allUrl('trend_pdf', '/download/pdf/trends/trend/'),
        observation: Restangular.allUrl('observation_pdf', '/download/pdf/trends/observation/'),
        list: Restangular.allUrl('list_pdf', '/download/pdf/trends/list/'),
        status: Restangular.allUrl('pdf_status', '/download/pdf/update_pdf_status/json/')
    };
    this.pptDownload = Restangular.allUrl('ppt_download', '/download/ppt/trends/request_static_ppt/');
    this.pptBuilderDownload = {
        request: Restangular.allUrl('pptbuilder_download', '/download/ppt/trends/download_trend_ppt/'),
        status: Restangular.allUrl('pptbuilder_status', '/download/ppt/trends/pptbuilder_status/')
    };

    this.productOption = Restangular.one('productoption');
    this.tour = Restangular.one('tour');
    this.autocomplete = Restangular.one('autocomplete');

    this.cachedRequest = function (resource, method, params) {
        return resource.withHttpConfig({cache: true})[method](params);
    };
    this.loggedIn = Restangular.one('login');
    this.usage = {
        viewdoc: Restangular.all('usage/viewdoc'),
        viewpage: Restangular.all('usage/viewpage'),
        search: Restangular.all('usage/search')
    };
    this.heatmap = Restangular.one('heatmap');
    this.ppt = Restangular.all('ppt');
    this.pptSelection = Restangular.all('pptselection');
    this.trendscape = {
        trend: Restangular.one('trendscape_trend'),
        observation: Restangular.one('trendscape_observation'),
        search: Restangular.one('trendscape_search'),
        hvt: Restangular.one('trendscape_hvt'),
        pillar: Restangular.one('trendscape_pillar')
    };
}]);

